import * as _ from "lodash";

export const isEmptyArray = (array: Array<any> | null | undefined) => {
    return !Array.isArray(array) || !array.length;
};

export const isNotEmptyArray = (array: Array<any> | null | undefined): array is Array<any> => {
    return !isEmptyArray(array);
};

export const arraysEqual = (array1: Array<any> | null | undefined, array2: Array<any> | null | undefined): boolean => {
    return _.isEqual(array1, array2);
};

export const arraysNotEqual = (
    array1: Array<any> | null | undefined,
    array2: Array<any> | null | undefined
): boolean => {
    return !arraysEqual(array1, array2);
};
